<template>
<div data-qa="logout-div-75e1lp"></div>
</template>
<script>
export default {
  created () {
    this.$logoutSetting.methods.systemLogout()
    // this.$router.push('/login')
  }
}
</script>
